/*
 * Common types for user/citizen profiles
 */

export enum StateNotUnknown {
    "AK - Alaska" = "AK",
    "AL - Alabama" = "AL",
    "AR - Arkansas" = "AR",
    "AS - American Samoa" = "AS",
    "AZ - Arizona" = "AZ",
    "CA - California" = "CA",
    "CO - Colorado" = "CO",
    "CT - Connecticut" = "CT",
    "DC - Washington, DC" = "DC",
    "DE - Delaware" = "DE",
    "FL - Florida" = "FL",
    "GA - Georgia" = "GA",
    "GU - Guam" = "GU",
    "HI - Hawaii" = "HI",
    "IA - Iowa" = "IA",
    "ID - Idaho" = "ID",
    "IL - Illinois" = "IL",
    "IN - Indiana" = "IN",
    "KS - Kansas" = "KS",
    "KY - Kentucky" = "KY",
    "LA - Louisiana" = "LA",
    "MA - Massachusetts" = "MA",
    "MD - Maryland" = "MD",
    "ME - Maine" = "ME",
    "MI - Michigan" = "MI",
    "MN - Minnesota" = "MN",
    "MO - Missouri" = "MO",
    "MP - Northern Mariana Islands" = "MP",
    "MS - Mississippi" = "MS",
    "MT - Montana" = "MT",
    "NC - North Carolina" = "NC",
    "ND - North Dakota" = "ND",
    "NE - Nebraska" = "NE",
    "NH - New Hampshire" = "NH",
    "NJ - New Jersey" = "NJ",
    "NM - New Mexico" = "NM",
    "NV - Nevada" = "NV",
    "NY - New York" = "NY",
    "NYC - New York City" = "NYC",
    "OH - Ohio" = "OH",
    "OK - Oklahoma" = "OK",
    "OR - Oregon" = "OR",
    "PA - Pennsylvania" = "PA",
    "PR - Puerto Rico" = "PR",
    "RI - Rhode Island" = "RI",
    "SC - South Carolina" = "SC",
    "SD - South Dakota" = "SD",
    "TN - Tennessee" = "TN",
    "TX - Texas" = "TX",
    "UT - Utah" = "UT",
    "VA - Virginia" = "VA",
    "VI - US Virgin Islands" = "VI",
    "VT - Vermont" = "VT",
    "WA - Washington" = "WA",
    "WI - Wisconsin" = "WI",
    "WV - West Virginia" = "WV",
    "WY - Wyoming" = "WY",    
}

export enum State {
    "Unknown" = "Unknown",
    "AK - Alaska" = "AK",
    "AL - Alabama" = "AL",
    "AR - Arkansas" = "AR",
    "AS - American Samoa" = "AS",
    "AZ - Arizona" = "AZ",
    "CA - California" = "CA",
    "CO - Colorado" = "CO",
    "CT - Connecticut" = "CT",
    "DC - Washington, DC" = "DC",
    "DE - Delaware" = "DE",
    "FL - Florida" = "FL",
    "GA - Georgia" = "GA",
    "GU - Guam" = "GU",
    "HI - Hawaii" = "HI",
    "IA - Iowa" = "IA",
    "ID - Idaho" = "ID",
    "IL - Illinois" = "IL",
    "IN - Indiana" = "IN",
    "KS - Kansas" = "KS",
    "KY - Kentucky" = "KY",
    "LA - Louisiana" = "LA",
    "MA - Massachusetts" = "MA",
    "MD - Maryland" = "MD",
    "ME - Maine" = "ME",
    "MI - Michigan" = "MI",
    "MN - Minnesota" = "MN",
    "MO - Missouri" = "MO",
    "MP - Northern Mariana Islands" = "MP",
    "MS - Mississippi" = "MS",
    "MT - Montana" = "MT",
    "NC - North Carolina" = "NC",
    "ND - North Dakota" = "ND",
    "NE - Nebraska" = "NE",
    "NH - New Hampshire" = "NH",
    "NJ - New Jersey" = "NJ",
    "NM - New Mexico" = "NM",
    "NV - Nevada" = "NV",
    "NY - New York" = "NY",
    "NYC - New York City" = "NYC",
    "OH - Ohio" = "OH",
    "OK - Oklahoma" = "OK",
    "OR - Oregon" = "OR",
    "PA - Pennsylvania" = "PA",
    "PR - Puerto Rico" = "PR",
    "RI - Rhode Island" = "RI",
    "SC - South Carolina" = "SC",
    "SD - South Dakota" = "SD",
    "TN - Tennessee" = "TN",
    "TX - Texas" = "TX",
    "UT - Utah" = "UT",
    "VA - Virginia" = "VA",
    "VI - US Virgin Islands" = "VI",
    "VT - Vermont" = "VT",
    "WA - Washington" = "WA",
    "WI - Wisconsin" = "WI",
    "WV - West Virginia" = "WV",
    "WY - Wyoming" = "WY",
};

export enum Race {
    "American Indian or Alaska Native" = "AMERICAN_INDIAN_OR_ALASKA_NATIVE",
    "Black or African American" = "BLACK_OR_AFRICAN_AMERICAN",
    "Asian" = "ASIAN",
    "Asian Indian" = "ASIAN_INDIAN",
    "White" = "WHITE",
    "Hispanic or Latino" = "HISPANIC_OR_LATINO",
    "Native Hawaiian or Pacific Islander" = "NATIVE_HAWAIIAN_OR_PACIFIC_ISLANDER",
    "Other" = "OTHER"
}

export enum Sex {
    "Male" = "MALE",
    "Female" = "FEMALE",
    "Non-Binary/Other" = "NON_BINARY",
}

export enum YesNoUnknown {
    "Yes" = "YES",
    "No" = "NO",
    "Unknown" = "UNKNOWN",
}

export enum AdoptionRequestType {
    "After" = "AFTER",
    "Prior" = "PRIOR",
    "N/A" = "NA",
}

export enum VotingIntent {
    "Not Sure" = "NOT_SURE",
    "Yes" = "YES",
    "No" = "NO",
    "Prefer not to say" = "PREFER_NOT_TO_SAY",
}

export interface Address {
    number?: string,
    street?: string,
    city?: string,
    state?: State,
    postalCode?: string,
    country?: string
}

export function formatUSAddressShort(address?: Address|null) {
    if (!address) return "";

    const parts = [];
    if (address.number) parts.push(address.number);
    if (address.street) parts.push(address.street);
    if (address.city) parts.push(address.city);
    if (address.state) parts.push(address.state);
    if (address.postalCode) parts.push(address.postalCode);
    return parts.join(", ");
}

export interface Sibling {
    name: string;
    dateOfBirth: Date;
}

export enum PossessedIdTypes {
    "None" = "NONE",
    "Primary" = "PRIMARY",
    "Secondary" = "SECONDARY",
}

export enum BirthDistrict {
    "St. Croix" = "STCROIX",
    "St. Thomas" = "STTHOMAS",

    // NYC
    "Bronx" = "BRONX",
    "Queens" = "QUEENS",
    "Manhattan" = "MANHATTAN",
    "Staten Island" = "STATEN_ISLAND",
    "Brooklyn" = "BROOKLYN",

    "N/A" = "NA",
}